export enum HttpClientType {
  Identity = 1,
  LightSail,
  MindPlay,
  Fluency,
  Screener,
  Phonics,
  Grammar,
  Academy,
}
